
import React from 'react';
import { UseFormReturn, ControllerRenderProps } from 'react-hook-form';
import type { BlogPostFormData } from '@/services/blog/types';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

interface SEOFieldsProps {
  form: UseFormReturn<BlogPostFormData>;
}

export const SEOFields: React.FC<SEOFieldsProps> = ({ form }) => {
  return (
    <>
      <FormField
        control={form.control}
        name="meta_title"
        render={({ field }: { field: ControllerRenderProps<BlogPostFormData, 'meta_title'> }) => (
          <FormItem>
            <FormLabel>Meta Title</FormLabel>
            <FormControl>
              <Input placeholder="SEO title (optional, defaults to main title)" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="meta_description"
        render={({ field }: { field: ControllerRenderProps<BlogPostFormData, 'meta_description'> }) => (
          <FormItem>
            <FormLabel>Meta Description</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="SEO description (optional, defaults to summary)" 
                className="min-h-[80px]"
                {...field} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
